import { CSS, StyleProps } from "@shared/primitive-components"

export const margin = (props: StyleProps) => ({
  margin: props.theme.spacing(0, 0, 7),
})

export const buttonWrapper = (): CSS => ({
  margin: `0.75rem auto`,
})
export const link = (props: StyleProps): CSS => ({
  ...props.theme.fonts.subHeading,
  borderBottom: `1px solid ${props.theme.palette.coal.light}`,
  borderRadius: 0,
  color: props.theme.palette.white,
  display: `inline-block`,
  padding: props.theme.spacing(2, 6),
  position: `sticky`,
  textAlign: `left`,
  width: `100%`,
  "&:hover": {
    color: props.theme.palette.white,
    background: props.theme.palette.coal.light,
  },
})
export const logOutLink = (props: StyleProps): CSS => ({
  ...link(props),
  borderTop: `1px solid ${props.theme.palette.coal.light}`,
})

export const brandMenuButton = (props: StyleProps): CSS => ({
  margin: props.theme.spacing(3, 0),
})

export const prevPolicyDropdownWrapper = (): CSS => ({
  width: `100%`,
})

export const logoContainer = (props: StyleProps): CSS => ({
  borderBottom: `1px solid ${props.theme.palette.coal.light}`,
  padding: `0 20px`,
  [props.theme.breakPoints.md.up]: {
    width: `100%`,
    padding: 0,
  },
})

export const burgerButton = (props: StyleProps): CSS => ({
  padding: `0`,
  "&:hover": {
    backgroundColor: `transparent`,
  },
  [props.theme.breakPoints.md.up]: {
    display: `none`,
  },
})

export const navContainer = (props: StyleProps): CSS => ({
  "overflow-y": `auto`,
  height: `100%`,
  scrollbarWidth: `thin`,
  "&::-webkit-scrollbar": {
    width: `4px`,
    backgroundColor: props.theme.palette.grey.light,
    borderRadius: `4px`,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: `rgba(0, 0, 0, 0.2)`,
    borderRadius: `4px`,
  },
})

export const navOptionsContainer = (): CSS => ({
  width: `100%`,
})
